import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaPhoneSlash } from 'react-icons/fa';
import { getAvatarUrl } from '../../utils/avatar';

const OutgoingCallModal = ({ callInfo, onCancel }) => {
  if (!callInfo) return null;

  const { callType, otherUser } = callInfo;
  const isVideo = callType === 'video';

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/70 backdrop-blur-sm"
        data-testid="outgoing-call-modal"
      >
        <motion.div
          initial={{ scale: 0.8, y: 40 }}
          animate={{ scale: 1, y: 0 }}
          exit={{ scale: 0.8, y: 40 }}
          transition={{ type: 'spring', damping: 25, stiffness: 300 }}
          className="bg-gray-900 rounded-3xl p-8 w-80 text-center shadow-2xl border border-gray-800"
        >
          {/* Ripple animation */}
          <div className="relative mx-auto w-28 h-28 mb-6">
            <div className="absolute inset-0 rounded-full border-2 border-blue-400/30 animate-ping" style={{ animationDuration: '2s' }} />
            <div className="absolute inset-[-8px] rounded-full border border-blue-400/20 animate-pulse" />
            <img
              src={getAvatarUrl(otherUser?.avatar_url, otherUser?.full_name)}
              alt={otherUser?.full_name}
              className="relative w-28 h-28 rounded-full object-cover border-4 border-blue-400/50"
              data-testid="outgoing-callee-avatar"
            />
          </div>

          <h2 className="text-white text-xl font-bold mb-1" data-testid="outgoing-callee-name">
            {otherUser?.full_name || 'Unknown'}
          </h2>
          <p className="text-gray-400 text-sm mb-1">@{otherUser?.username || 'user'}</p>

          {/* Calling status with animated dots */}
          <div className="text-blue-400 text-sm font-medium mb-8 flex items-center justify-center gap-1" data-testid="outgoing-call-status">
            <span>{isVideo ? 'Video' : 'Voice'} Calling</span>
            <span className="flex gap-0.5">
              <span className="animate-bounce inline-block" style={{ animationDelay: '0s' }}>.</span>
              <span className="animate-bounce inline-block" style={{ animationDelay: '0.2s' }}>.</span>
              <span className="animate-bounce inline-block" style={{ animationDelay: '0.4s' }}>.</span>
            </span>
          </div>

          <button
            onClick={onCancel}
            className="w-16 h-16 mx-auto rounded-full bg-red-500 hover:bg-red-600 flex items-center justify-center transition-all hover:scale-110 shadow-lg shadow-red-500/30"
            data-testid="cancel-call-btn"
          >
            <FaPhoneSlash className="text-white text-xl" />
          </button>
          <p className="text-gray-500 text-xs mt-3">Tap to cancel</p>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default OutgoingCallModal;
